import './Contact.css'
import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
    const form = useRef();

    const sendEmail = e => {
        e.preventDefault();
        const alert = toast.loading("Sending......")

        emailjs.sendForm('gmail', 'template_0oe66oa', form.current, 'user_zfeVGiQC9Wx736sdiVg7q')
            .then((result) => {
                console.log(result.text);
                toast.update(alert, { render: 'Message sent, Thanks.', type: 'success', isLoading: false, autoClose: 2000 })
            }, (error) => {
                console.log(error.text);
                toast.update(alert, { render: 'Failed! please try again.', type: 'error', isLoading: false, autoClose: 2000 })
            });

    }


    return (
        <div className='contact' id='contact-me'>
            <div className="contact-grid">

                <div className="left">
                    <h3>Hi, let's talk about your project!</h3>
                    <br /><br />
                    <p><b>Protip </b>— touch on these things:</p>
                    <p>
                        - Your idea <br />
                        - Your timeline <br />
                        - Your budget <br />
                    </p>
                </div>
                <form
                    ref={form}
                    onSubmit={sendEmail}
                    className='contact-form'
                >
                    <input
                        type="text"
                        name="name"
                        required
                        placeholder='Enter Your Name'
                    />
                    <br />
                    <input
                        type="email"
                        name="email"
                        required
                        placeholder='Enter Your Email'
                    />
                    <br />
                    <textarea
                        name="message"
                        rows="5"
                        required
                        placeholder='Enter Your message'
                    ></textarea>
                    <button className='btn-primary' type="submit">Send message</button>
                </form>

            </div>



            {/* Toastify */}
            <ToastContainer
                position="bottom-right"
                autoClose={2500}
                hideProgressBar={false}
            />
        </div>
    );
};

export default Contact;